import { DynamoDBClient, ScanCommand } from '@aws-sdk/client-dynamodb';
import { NORMALIZED_STAGE, ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';
import { CognitoService } from 'src/services/aws/CognitoService';

export interface DashboardConfig {
  dashboardId: string;
  dashboardName: string;
  displayName: string;
  description: string;
  displayOrder: number;
}

const TABLE_NAME = `finsuite_dashboards_${NORMALIZED_STAGE}`;

let _client: DynamoDBClient | null = null;

const getClient = (): DynamoDBClient => {
  if (!_client) {
    _client = new DynamoDBClient({
      region: ENVIRONMENT_VARIABLES.env.Region,
      credentials: CognitoService.credentialProvider
    });
  }
  return _client;
};

/**
 * Fetches dashboard configurations from the DynamoDB registry table.
 * Returns entries sorted by displayOrder.
 */
export const fetchDashboardConfigs = async (): Promise<DashboardConfig[]> => {
  try {
    const result = await getClient().send(new ScanCommand({ TableName: TABLE_NAME }));

    const dashboards: DashboardConfig[] = (result.Items || [])
      .filter((item) => item.dashboardId?.S && item.dashboardName?.S && item.displayName?.S)
      .map((item) => ({
        dashboardId: item.dashboardId!.S!,
        dashboardName: item.dashboardName!.S!,
        displayName: item.displayName!.S!,
        description: item.description?.S || '',
        displayOrder: Number(item.displayOrder?.N || '0')
      }));

    dashboards.sort((a, b) => a.displayOrder - b.displayOrder);
    return dashboards;
  } catch (error) {
    console.error('fetchDashboardConfigs: Failed to load dashboards', error);
    throw error;
  }
};
